<template>
    <div
      class="modal-warning"
    >    
        <div
            v-if="correct === 'correct'"
            class="correct-warning"
        >
            <div
                v-html="warningText"
                class="warning-text">
                
            </div>
            
        </div>
        <div
            v-else-if="correct === 'notCorrect'"
            class="not-correct-warning"
        >
            <div
                v-html="warningText"
                class="warning-text">
            </div>
        </div>
        <div
            v-else-if="correct === 'partlyCorrect'"
            class="partly-correct-warning"
        >
            <div
                v-html="warningText"
                class="warning-text warning-text-hint">
            </div>
        </div>
        
    </div>      
</template>

<script>
export default {
    name: 'ModalWarning',
    props: {
        correct: String,
        warningText: String
    }
}
</script>

<style>
    
</style>